let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cMSkI")).then(() => parcelRequire('l1L3U'));